<template>
  <b-row>
    <div
      class="p-5 d-flex align-items-center text-center flex-grow-1"
      v-if="$context.state.globalError"
    >
      <b-col cols="12">
        <b-row>
          <b-col>
            <h1>{{ $context.state.globalErrorData.code }}</h1>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            {{ $context.state.globalErrorData.message }}
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-link href="/">
              <b-btn variant="primary" class="col-md-12">
                Powrót do strony głównej
              </b-btn>
            </b-link>
          </b-col>
        </b-row>
      </b-col>
    </div>
  </b-row>
</template>

<script>
export default {
  name: 'global-error-overlay'
}
</script>

<style scoped>
</style>
